import React from "react";
import { Button, Col, Divider, Form, Row } from "antd";
import PageContainer from "../../../components/PageContainer";

function PaymentResult(props) {
  const { result = true, paymentCode, bankGate } = props;
  return (
    <PageContainer
      classNames="payment-result"
      headerProps={{
        link: "/",
        content: "پرداخت",
        className: "",
      }}
    >
      <Row className="mt-4">
        <Col span={24}>
          <span className="icon-logo" />
          <div className="wrapper">
            <div className="rows">
              <span
                className={`${
                  result ? "icon-chat-tik-green" : "icon-chat-close-border-red"
                }`}
              />
            </div>
            <div className="rows">
              <div className="result-description">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است.
              </div>
              <div className="payment-details">
                <div className="rows">
                  <div className="title">شناسه پرداخت:</div>
                  <div className="text">{paymentCode}</div>
                </div>
                <Divider />
                <div className="rows">
                  <div className="title">هزینه پرداخت شده:</div>
                  <div className="text">
                    <strong>200.000</strong>
                    <small>تومان</small>
                  </div>
                </div>
                <Divider />
                <div className="rows">
                  <div className="title">وضعیت پرداخت:</div>
                  <div className={`text ${result ? "success" : "failed"}`}>
                    {result ? "موفق" : "ناموفق"}
                  </div>
                </div>
                <Divider />
                <div className="rows">
                  <div className="title">درگاه بانکی:</div>
                  <div className="text paygate">{bankGate}</div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className="submit-btn center-text mt-4 pt-2">
        <Form.Item>
          <Button
            type="primary"
            shape="round"
            htmlType="submit"
          >
            {result ? "تایید" : "تلاش دوباره"}
          </Button>
        </Form.Item>
      </div>
    </PageContainer>
  );
}

export default PaymentResult;
